<template>
  <teleport to="body">
    <div v-if="openModal" class="modal" @click.self.prevent="closeModal">
      <div class="opHoursModal">
        <font-awesome-icon icon="fa-xmark" class="exit" @click="closeModal" />
        <div class="hours-container">
          <div class="hours-header">
            <div class="header">
              <!-- <font-awesome-icon class="backward" icon="backward" @click.stop.prevent="$router.go(-1)"></font-awesome-icon> -->
              <!-- make this a one line?? -->
              <h1 v-if="!delivery">{{ currentSite }} Operating Hours</h1>
              <h1 v-if="delivery">{{ currentSite }} Delivery Operating Hours</h1>
            </div>
            <div class="match-toggle">
              <h4>Match delivery hours to opening hours</h4>
              <ToggleSwitch :modelName="'matchWebHours'" :modelValue="matchWebHours" @update:modelValue="setMatchWebHours" />
            </div>
            <div class="select-region">
              <h4 v-if="selectedRegion">Region: {{ selectedRegion }}</h4>
              <h4 v-else>Select a region</h4>
              <select name="region" id="region" v-model="selectedRegion" @change="setRegion">
                <option value="" selected>Change Region</option>
                <option v-for="region in regions" :key="region" :value="region">{{ region }}</option>
              </select>
            </div>
            <button class="save" @click.stop.prevent="saveOpeningHours">Save Opening Hours</button>
          </div>
          <div class="hours">
            <ul>
              <div class="ul-header">
                <h2>Store Operating Hours</h2>
              </div>
              <div class="set-all">
                <button v-if="!setAllDays" @click.stop.prevent="showSetAll('week')" class="set-btn">Set all days</button>
              </div>
              <div v-if="setAllDays" class="all-set">
                <DayOperatingHours
                  :modelName="'weekdays'"
                  :open="daySetOpen"
                  :openTime="daySetOpenTime"
                  :closeTime="daySetCloseTime"
                  @setOpenTime="daySetOpenTime = $event"
                  @setCloseTime="daySetCloseTime = $event"
                  @setOpen="daySetOpen = $event" />
                <button @click.stop.prevent="updateDays" class="set-btn">Save</button>
              </div>
              <li v-for="day in weekFinal" :key="day.name">
                <div class="days">
                  <span>{{ day.name }}</span>
                  <DayOperatingHours
                    :modelName="day.name"
                    :open="day.open"
                    :openTime="day.openTime"
                    :closeTime="day.closeTime"
                    @setOpenTime="day.openTime = $event"
                    @setCloseTime="day.closeTime = $event"
                    @setOpen="day.open = $event" />
                </div>
              </li>
            </ul>
            <ul>
              <div class="ul-header">
                <button v-if="currentYear == nextYear" class="set-btn action-colour" @click.stop.prevent="updateYear(thisYear)"><font-awesome-icon icon="fa-arrow-left" /></button>
                <h2>{{ currentYear }} Public Holidays</h2>
                <button v-if="currentYear == thisYear" class="set-btn action-colour" @click.stop.prevent="updateYear(nextYear)"><font-awesome-icon icon="fa-arrow-right" /></button>
              </div>
              <div class="surcharge">
                <div class="unit">
                  <h3>Automatic Surcharge:</h3>
                  <ToggleSwitch :modelName="'autoSurcharge'" :modelValue="autoSurcharge" @update:modelValue="saveAutoSurcharge($event)" />
                </div>
                <div class="unit">
                  <h3>Surcharge Rate (%):</h3>
                  <input
                    type="number"
                    class="input"
                    id="surchargeInput"
                    min="0"
                    max="100"
                    @change="($event) => (surchargeView = $event.target.value)"
                    :value="surchargeView"
                    @click.stop.prevent="this.editSurcharge = true" />
                </div>
                <font-awesome-icon v-if="editSurcharge" icon="floppy-disk" class="edit blue" @click.stop.prevent="saveSurcharge" />
              </div>
              <div class="set-all">
                <button v-if="!setAllHolidays" @click.stop.prevent="showSetAll('holiday')" class="set-btn">Set all Holidays</button>
              </div>
              <div v-if="setAllHolidays">
                <DayOperatingHours
                  v-if="setAllHolidays"
                  :modelName="'holidays'"
                  :open="holidaySetOpen"
                  :openTime="holidaySetOpenTime"
                  :closeTime="holidaySetCloseTime"
                  @setOpenTime="holidaySetOpenTime = $event"
                  @setCloseTime="holidaySetCloseTime = $event"
                  @setOpen="holidaySetOpen = $event" />
                <button @click.stop.prevent="updateHolidayDays" class="set-btn">Save</button>
              </div>
              <li v-for="holiday in filterHolidayFinal" :key="holiday">
                <div v-if="holiday.name != ''" class="days">
                  <span>{{ holiday.name }} {{ holiday.date }}</span>
                  <DayOperatingHours
                    :modelName="holiday.name"
                    :open="holiday.open"
                    :openTime="holiday.openTime"
                    :closeTime="holiday.closeTime"
                    @setOpenTime="holiday.openTime = $event"
                    @setCloseTime="holiday.closeTime = $event"
                    @setOpen="holiday.open = $event" />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DayOperatingHours from "./DayOperatingHours.vue";
import ToggleSwitch from "./ToggleSwitch.vue";
import { holidays2025, holidays2026 } from "@monolith/helpers";

export default {
  name: "OperatingHoursModal",
  components: {
    DayOperatingHours,
    ToggleSwitch,
  },
  props: {
    openModal: {
      type: Boolean,
      required: true,
    },
    currentSite: {
      type: String,
      required: false,
    },
    delivery: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["closeModal"],
  data() {
    return {
      thisYear: new Date(Date.now()).getFullYear(),
      nextYear: new Date(Date.now()).getFullYear() + 1,
      currentYear: new Date(Date.now()).getFullYear(),
      orderStatus: "In Progress",
      daySetOpen: false,
      daySetOpenTime: "08:30",
      daySetCloseTime: "14:30",
      holidayDays: {},
      weekDays: {},
      holidaySetOpen: false,
      holidaySetOpenTime: "08:30",
      holidaySetCloseTime: "14:30",
      holidayFinal: [],
      holidays: [],
      weekFinal: [],
      daysOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      setAllDays: false,
      setAllHolidays: false,
      autoSurcharge: "", //toggle
      surchargeRate: "", //input
      surchargeView: false,
      editSurcharge: false, //for the save button
      selectedRegion: "",
      matchWebHours: false, //toggle to match web hours
      regionalHolidayFound: false,
    };
  },

  methods: {
    ...mapActions(["updateSettings"]),

    setMatchWebHours() {
      this.matchWebHours = !this.matchWebHours; // toggle this elsewhere and update on watch?
      // this.$store.dispatch("setMatchWebHours", this.matchWebHours);
      // if(this.matchWebHours) {
      //   channel.push("company:site:setting", { key: "delivery_hours", value: openingHours.hours });
      // } else {
      // }
    },

    checkRegion() {
      if (!("hours" in this.settings)) {
        return;
      } else {
        if (`holiday${this.currentYear}` in this.settings.hours) {
          this.settings.hours["holiday" + this.currentYear].forEach((h) => {
            if (h.regional == true) {
              this.regionalHolidayFound = true;
              let n = h.name
                .split(" ")
                .splice(0, h.name.split(" ").length - 2)
                .join(" ");
              this.selectedRegion = n;
            }
          });
        }
      }
    },

    setRegion() {
      this.holidayFinal = this.holidayFinal.filter((h) => h.regional !== true);

      if (this.selectedRegion && this.regionalHoliday && this.regionalHoliday.length > 0) {
        this.regionalHoliday.forEach((holiday) => {
          let regHol = {
            name: holiday.HolidayName,
            open: false,
            openTime: holiday.OpenTime || "",
            closeTime: holiday.CloseTime || "",
            date: this.adjustDateToCurrentYear(holiday.ActualDate),
            regional: true,
          };
          this.holidayFinal.push(regHol);
        });
      }
    },

    showSetAll(type) {
      if (type == "week") {
        this.setAllDays = !this.setAllDays;
      } else {
        this.setAllHolidays = !this.setAllHolidays;
      }
    },

    updateDays() {
      this.weekFinal.forEach((day) => {
        day.open = this.daySetOpen;
        day.openTime = this.daySetOpenTime;
        day.closeTime = this.daySetCloseTime;
      });
      this.setAllDays = false;
    },

    updateYear(year) {
      this.setYear(year);
      if ("hours" in this.settings && "holiday" + this.currentYear in this.settings.hours && this.settings.hours["holiday" + this.currentYear].length > 0) {
        this.holidayFinal = this.settings.hours["holiday" + this.currentYear].map((holiday) => ({
          ...holiday,
          date: this.adjustDateToCurrentYear(holiday.date),
        }));
      } else {
        this.holidayFinal = this.holidayObj;
      }
    },

    updateHolidayDays() {
      this.holidayFinal.forEach((day) => {
        day.open = this.holidaySetOpen;
        day.openTime = this.holidaySetOpenTime;
        day.closeTime = this.holidaySetCloseTime;
      });
      this.setAllHolidays = false;
    },

    setYear(year) {
      if (this.thisYear.toString() == year.toString()) {
        this.holidays = holidays2025;
      } else if (this.nextYear.toString() == year.toString()) {
        this.holidays = holidays2026;
      }
      this.currentYear = year;
    },

    async saveOpeningHours() {
      let openingHours = {
        site: this.site,
        hours: {
          [`holiday${this.currentYear}`]: this.holidayFinal,
          week: this.weekFinal,
        },
      };

      if (this.delivery) {
        this.channel.push("company:site:setting", { site: this.site, key: "delivery_hours", value: openingHours.hours });
      } else {
        this.channel.push("company:site:setting", { site: this.site, key: "hours", value: openingHours.hours });
      }

      this.closeModal();
    },

    saveSurcharge() {
      this.editSurcharge = !this.editSurcharge; //get rid of the save button
      let rate = this.convertSurcharge(this.surchargeView); //convert the input value to a float`
      this.channel.push("company:site:setting", { key: "surcharge_rate", value: rate }); //push the changes to settings
    },

    convertSurcharge(amount) {
      // Convert the input value to a float and divide by 100 to get the percentage
      return (parseFloat(amount) / 100).toFixed(2);
    },

    adjustDateToCurrentYear(dateString) {
      if (!dateString) return dateString;

      // Handle different date formats
      let date;
      if (dateString.includes("-")) {
        const parts = dateString.split("-");
        if (parts[0].length === 4) {
          date = new Date(`${this.currentYear}-${parts[1]}-${parts[2]}`);
        } else {
          date = new Date(`${this.currentYear}-${parts[1]}-${parts[0]}`);
        }
      } else if (dateString.includes("/")) {
        const parts = dateString.split("/");
        if (parts.length === 3) {
          date = new Date(`${this.currentYear}-${parts[1]}-${parts[0]}`);
        }
      } else {
        date = new Date(dateString);
        date.setFullYear(this.currentYear);
      }

      if (dateString.includes("-")) {
        const parts = dateString.split("-");
        if (parts[0].length === 4) {
          return `${this.currentYear}-${parts[1]}-${parts[2]}`;
        } else {
          return `${parts[0]}-${parts[1]}-${this.currentYear}`;
        }
      } else if (dateString.includes("/")) {
        const parts = dateString.split("/");
        return `${parts[0]}/${parts[1]}/${this.currentYear}`;
      } else {
        return date.toISOString().split("T")[0];
      }
    },

    saveAutoSurcharge(value) {
      this.channel.push("company:site:setting", { key: "auto_surcharge", value: value });
    },

    closeModal() {
      this.$emit("closeModal", false);
    },
  },

  computed: {
    ...mapGetters({
      futurePickup: "futurePickup",
      siteSettings: "siteSettings",
      getWebOrder: "getWebOrder",
      companySettings: "companySettings",
    }),

    filterHolidayFinal() {
      return this.holidayFinal.filter((h) => h.name !== "Unscheduled Close");
    },

    regions() {
      const regionNames = this.holidays
        .filter((hol) => hol.Type === "Regional")
        .map((hol) => {
          return hol.HolidayName.split(" ").slice(0, -2).join(" ");
        });

      return [...new Set(regionNames)];
    },

    settings() {
      if (process.env.VUE_APP_FEATURE_FLAGS === "pos") {
        return this.siteSettings;
      } else {
        return this.siteSettings[this.currentSite];
      }
    },

    regionalHoliday() {
      return this.holidays.filter((hol) => hol.Type == "Regional" && hol.HolidayName.includes(this.selectedRegion));
    },

    natHolidays() {
      const nats = this.holidays.filter((hol) => hol.Type == "National");
      // nats.push(new Proxy({ HolidayName: "", ActualDate: "", Regional: true }, {}));
      return nats;
    },

    formattedDate() {
      const date = new Date(this.getWebOrder.order.pickup_date);
      return date.toDateString();
    },

    holidayObj() {
      let holidays = this.natHolidays.map((day) => {
        const dayOpen = {
          open: false,
          openTime: "",
          closeTime: "",
          name: "",
          date: "",
          regional: false,
        };
        dayOpen.name = day.HolidayName;
        dayOpen.date = this.adjustDateToCurrentYear(day.ActualDate);
        dayOpen.regional = day.Regional;
        return dayOpen;
      });

      if (this.selectedRegion) {
        const regionalHols = this.regionalHoliday.map((day) => {
          const dayOpen = {
            open: false,
            openTime: "",
            closeTime: "",
            name: "",
            date: "",
            regional: true,
          };
          dayOpen.name = day.HolidayName;
          dayOpen.date = this.adjustDateToCurrentYear(day.ActualDate);
          dayOpen.regional = true;
          return dayOpen;
        });

        holidays = [...holidays, ...regionalHols];
      }
      return holidays;
    },

    weekObj() {
      return this.daysOfWeek.map((day) => {
        const dayOpen = { open: false, openTime: "", closeTime: "", name: "" };
        dayOpen.name = day;
        return dayOpen;
      });
    },
  },

  mounted() {
    this.setYear(this.thisYear);
    this.checkRegion();
    this.updateYear(this.currentYear);

    if ("hours" in this.settings && "week" in this.settings.hours) {
      this.weekFinal = this.settings.hours["week"];
    } else {
      this.weekFinal = this.weekObj;
    }
    this.autoSurcharge = this.settings.auto_surcharge || false;
    this.surchargeRate = this.settings.surcharge_rate || 0.15;

    this.surchargeView = this.settings.surcharge_rate * 100;
  },

  watch: {
    // should there be a watch on auto surcharge?
    // so that if today is a public holiday and the auto surcharge is set to true, it will automatically add the surcharge
    selectedRegion() {
      if (!("hours" in this.settings && "holiday" + this.currentYear in this.settings.hours)) {
        this.holidayFinal = this.holidayObj;
      }
    },
  },
};
</script>

<style lang="scss">
@use "@monolith/styles";
h1,
h2,
h3 {
  color: var(--text-colour);
}

.exit {
  margin: 0.5rem;
}
.opHoursModal {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  .hours-container {
    display: flex;
    flex-direction: column;
    background-color: var(--primary-colour);
    border-radius: 20px;
    margin: auto;
    padding: 0;
    width: 100%;
    .hours-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin: 2rem;
      text-transform: capitalize;
      width: calc(100% - 4rem);
      .header {
        flex-grow: 1;
      }
      .save {
        background-color: var(--action-colour);
        color: var(--secondary-text-colour);
        border: none;
        box-shadow: var(--box-shadow);
      }
      .select-region,
      .match-toggle {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 1rem;
        margin: 0.5rem 1rem;
        width: 12rem;
        h4 {
          margin: 0.5rem 1rem;
          text-transform: capitalize;
          text-align: center;
          color: var(--action-colour);
        }
        select {
          margin: 1rem 0;
          padding: 0.5rem;
          border-radius: 5px;
          height: 40px;
          background-color: var(--tertiary-colour);
          color: var(--text-colour);
          border: none;
          box-shadow: var(--box-shadow);
        }
      }
    }
    .hours {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: flex-start;
      ul {
        padding: 2rem;
        margin: 1rem;
        background-color: var(--secondary-colour);
        border-radius: 20px;
        .ul-header {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          button {
            padding: 0.5rem 1rem;
            margin: 0 0.5rem;
            background-color: var(--primary-colour);
            box-shadow: var(--box-shadow);
          }
          h2 {
            min-width: 4rem;
            text-wrap: nowrap;
          }
        }

        .surcharge {
          display: flex;
          flex-direction: row;
          margin: 0.5rem 1rem;
          padding: 1rem 0rem;

          .unit {
            padding: 1rem;
            width: 50%;
            button {
              padding: 1rem;
            }
            input {
              align-items: center;
              background-color: var(--primary-colour);
            }
          }
          .checkbox {
            display: none;
          }
          h3 {
            margin: 0.5rem 0;
            text-wrap: nowrap;
            text-transform: capitalize;
            text-align: center;
          }
          input {
            background: var(--secondary-colour);
            box-shadow: var(--box-shadow);
            color: var(--text-colour);
            border: none;
            font-size: 1.25rem;
            border-radius: 5px;
            padding: 0.5rem;
            margin-top: 1rem;
            margin-left: 1rem;
          }
          .edit {
            //need to fix this
            color: var(--action-colour);
            cursor: pointer;
            margin-left: 4.5rem;
            margin-top: 4rem;
          }
        }

        div {
          button {
            padding: 0 1rem;
            margin: 0.5rem;
          }
        }
        .set-all {
          display: flex;
          justify-content: flex-start;
          height: 4rem;
          .set-btn {
            color: var(--text-colour) !important;
            margin-left: 0;
            background-color: var(--primary-colour);
            border: none !important;
            box-shadow: var(--box-shadow);
          }
        }
        li {
          list-style: none;
          margin: 0.5rem;
          .days {
            span {
              width: 150px;
            }
            display: flex;
            align-items: center;
            justify-content: flex-start;
          }
        }
      }
    }
  }
}

@media only screen and (orientation: portrait) {
  .modal {
    .opHoursModal {
      border-radius: 0.5rem;
      width: 90% !important;
      .hours-container {
        flex-direction: column;
        align-items: center;
        max-width: 100%;
        .hours-header {
          flex-direction: column;
          align-items: center;
          margin: 0;
          width: 100%;
          h1 {
            margin: 1rem;
            text-align: center;
          }
          button {
            margin: 1rem;
          }
          .match-toggle {
            .no-label {
              height: 28px !important;
            }
          }
        }
        .hours {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          max-width: 100% !important;
          ul {
            display: flex;
            flex-direction: column;
            padding: 0;
            align-items: center;
            justify-content: center;
            max-width: 90% !important;
            box-shadow: none;
            .ul-header {
              justify-content: center;
              padding: 2rem;
              max-width: 80%;
              h2 {
                text-wrap: wrap;
              }
            }
            .year-change {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              width: 30%;
              h2 {
                margin: 1rem;
                min-width: 4rem;
              }
            }
            li {
              display: flex;
              flex-direction: column;
              justify-content: space-evenly;
              align-items: center;
              max-width: 80%;
              .days {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                span {
                  width: 100%;
                  margin: 0.5rem auto;
                }
              }
            }
            .surcharge {
              flex-direction: column;
              padding: 0;
              .unit {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 80% !important;
                input {
                  max-width: 40%;
                }
              }
            }
            .all-set {
              display: flex;
              flex-flow: column;
              align-items: center;
              button {
                color: var(--text-colour) !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
